import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

export default function PageNotFound () {

    const parameters = useSelector(state => state.Parameters);

    return (
        <div className="pageNotFound">
            <image src={parameters.logo} alt='Logo' className="logo"/>
            <div className="container">
                    <h2>
                        Page Not Found
                    </h2>

                    <div className="logoContainer">
                        <img src={parameters.logo} alt='Logo' className="logo"/>
                    </div>
                    

                    <div className='errorBtns'>
                        <Link className="btn btn-rounded btn-danger btn-rounded" to='/projects'>Back to website</Link>
                    </div>
            </div>
        </div>
    )
}